import { Form } from "antd";

import { getValidationRules } from "../../components/Validations/ValidationFieldsFactory";
import type { FieldMethod, FormFieldFactoryProps, ValidationRule } from "../../types/types";
import { NumberInput } from "./NumberInput";

export const NumberField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    let numberRules = rules ? [...rules] : [];
    const fieldValidations = field.attributes?.validationRules || [];

    const hasSetPattern = fieldValidations.some((rule) => rule.name === "Pattern");
    if (!hasSetPattern) {
        const numberPatternValidation = getValidationRules([{ name: "Pattern", params: ["^[0-9]*$"] } as ValidationRule]);
        numberRules = [...numberRules, ...numberPatternValidation];
    }

    const hasSetMaxLength = fieldValidations.some((rule) => rule.name === "MaxLength");
    if (!hasSetMaxLength) {
        const numberLengthValidation = getValidationRules([{ name: "MaxLength", params: [9] } as ValidationRule]);
        numberRules = [...numberRules, ...numberLengthValidation];
    }

    const hasSetMax = fieldValidations.some((rule) => rule.name === "MaxValue");
    if (!hasSetMax) {
        const numberMaxValidation = getValidationRules([{ name: "MaxValue", params: [999999999] } as ValidationRule]);
        numberRules = [...numberRules, ...numberMaxValidation];
    }

    const hasSetMin = fieldValidations.some((rule) => rule.name === "Min");
    if (!hasSetMin) {
        const numberMinValidation = getValidationRules([{ name: "Min", params: [0] } as ValidationRule]);
        numberRules = [...numberRules, ...numberMinValidation];
    }

    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={numberRules}>
            <NumberInput key={field.name} name={field.name} label={field.translationKeys.label} readOnly={readOnly} />
        </Form.Item>
    );
};
